<template>
	<el-container style="height:100%;">

		<el-container class="cal-height">
			<Aside @loginDialog="toLogin"></Aside>
			<!-- <router-view name="helper"></router-view> -->
			<el-main ref="el_main" style="padding: 0;overflow:hidden;position: relative;height:100%;width: 100%;"><!-- 全局loading -->
				<!-- <div class="loader loading-box" style="display: none">
          <div class="loader-inner ball-pulse">
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div> -->
				<keep-alive :include="whitePage">
					<router-view name="helper" />
				</keep-alive>
			</el-main>
			<RightNav @loginDialog="toLogin"></RightNav>
		</el-container>
		<!-- 上传文件弹框 -->
		<el-dialog class="wis-confirm-dialog upload-file-loading " :close-on-click-modal="false" :modal="true"
			:visible.sync="uploadFileDialogVisible" width="500px">
			<div class="top-pic">
				<div class="top-line"></div>
				<img src="../assets/images/modal.png" alt="" />
			</div>
			<!-- 文件上传中... -->
			<div class="top-tit fwb" v-if="percentage < 100">
				{{ $t("upload.uploading") }}
			</div>
			<!-- 上传完成 -->
			<div class="top-tit fwb" v-if="percentage >= 100">
				{{ $t("upload.uploadComplete") }}
			</div>
			<div class="mtl" style="color:#333;">
				<el-progress type="circle" :percentage="percentage" color="#4b9df1" :stroke-width="10"></el-progress>
			</div>
			<div slot="footer" class="dialog-footer t-center">
				<!-- <button type="button" class="wis-default-a confirm" v-if="percentage<100"
        @click="uploadFileDialogVisible = false" style="width: 140px!important">取消上传</button> -->
				<!-- 关 &nbsp; 闭 -->
				<button type="button" class="wis-default-a confirm" @click="closeUploadFileDialog"
					style="width: 140px!important">
					{{ $t("upload.close") }}
				</button>
			</div>
		</el-dialog>
		<!--neo二维码弹出框-->
		<el-dialog class="neoCode " :visible.sync="$store.state.common.neoCodeVisible" width="14.4rem" 
			@close="closeNeoCodeVisible" >
			<div class="t-center">
				<!-- 扫描安装neo -->
				<div class="title">{{ $t("neo.setup") }}</div>
				<div style="margin-bottom: 0.8rem;">
					<img src="../assets/images/neoCode.png" style="width:4.8rem"/>
				</div>
				<!-- 使用手机扫描二维码 -->
				<span class="tips">{{ $t("neo.ScanQR") }}</span>
				<div style="height: 0.8rem;"></div>
			</div>
		</el-dialog>
		<!--neo二维码弹出框end -->
		<!--dyned 跳转弹出框start-->
		<el-dialog class="neoCode " :visible.sync="$store.state.common.dynedJumpVisible" width="300px" center
			@close="closeDynedJumpVisible">
			<div class="t-center">
				<span class="title">{{ $t("common.titleTips") }}</span>
				<div class="download-dyned">
					<div class="download-dyned-link" @click="downloadDyned()">
						{{ $t("dyned.clickDownload") }}
					</div>
					<div class="mtm has-download">{{ $t("dyned.hasDownload") }}</div>
				</div>
			</div>
		</el-dialog>
		<!--dyned 跳转弹出框end -->

		<!-- 切换语言弹出框 -->
		<el-dialog :title="$t('lang.languageTips')" class="wis-dialog"
			:visible.sync="$store.state.common.languageDialogVisible" width="14.4rem" :modal-append-to-body="true">
			<div class="language-dialog">
				<el-radio-group v-model="language">
					<el-radio label="zh">{{ $t("lang.zh") }}</el-radio>
					<el-radio label="en">{{ $t("lang.en") }}</el-radio>
					<el-radio label="tw">{{ $t("lang.tw") }}</el-radio>
				</el-radio-group>
			</div>
			<span slot="footer" class="dialog-footer">
				<button class="m-btn cancel" @click="closeLanguageDialog('cancel')">
					{{ $t("common.cancel") }}
				</button>
				<button class="m-btn main confirm" @click="closeLanguageDialog('confirm')">
					{{ $t("common.confirm") }}
				</button>
			</span>
		</el-dialog>

		<external-login v-if="ischeckPhone" @closeClick="closeClick"></external-login>
	</el-container>
</template>

<script>
	import Aside from "./Aside.vue";
	import TopBar from "./TopBar.vue";
	import externalLogin from "./externalLogin";
	import RightNav from "./RightNav.vue";
	export default {
		data() {
			return {
				recommenderId: null,
				ischeckPhone: false,
				//  header: this.$route.name,
				nowTime: new Date().getTime(),
				expiryTimeTitle: "",
				expiryTimeContent: "",
				trialStatus: 0,
				language: this.$store.state.common.lang,
				whitePage: []
				// uploadFileDialogVisible: false,
				// percentage: 0,
			};
		},
		components: {
			Aside,
			TopBar,
			externalLogin,
			RightNav
		},
		watch: {
			uploadFileDialogVisible(val) {
				this.$store.dispatch("common/changeUploadFileDialogVisible", val);
			},
			languageDialogVisible(val) {
				this.language = this.$store.state.common.lang;
			}
		},

		mounted() {
			let locationReash = localStorage.getItem('locationReash')
			if (locationReash) {
				this.ischeckPhone = true;
				localStorage.removeItem('locationReash')
			}

		},
		watch: {
			$route: {
				handler(val, oldval) {
					this.activeDate = new Date().getTime();
					if (this.$route.path == "/learning/index") {
						this.whitePage = [];
					} else {
						this.whitePage = this.$store.state.common.keepAlive;
					}

					console.log("白名单===》", this.whitePage);
				},
				// 深度观察监听
				deep: true
			}
		},
		computed: {
			percentage() {
				return this.$store.state.common.uploadFilePercent;
			},
			uploadFileDialogVisible() {
				return this.$store.state.common.uploadFileDialogVisible;
			},
			languageDialogVisible() {
				return this.$store.state.common.languageDialogVisible;
			}
		},
		methods: {
			toLogin() {
				this.ischeckPhone = true;
			},
			closeClick(val) {
				this.ischeckPhone = false;
			},
			createLogin(val) {
				window.location.reload();
			},
			closeUploadFileDialog() {
				this.$store.dispatch("common/changeUploadFileDialogVisible", false);
			},
			closeNeoCodeVisible() {
				this.$store.dispatch("common/changeNeoCodeVisible", false);
			},
			closeDynedJumpVisible() {
				this.$store.dispatch("common/changeDynedJumpVisible", false);
			},
			downloadDyned() {
				window.open("http://web2.dyned.com/download/student.shtml.zh_CN");
			},
			closeLanguageDialog(type) {
				if (type == "confirm") {
					this.$i18n.locale = this.language;
					this.$store.dispatch("common/changeLang", this.language);
					document.title = this.$t("common.documentTitle");
				}
				// 存到数据库中
				let data = {};
				let lang = this.language;
				data.userId = localStorage.getItem("userId");
				data.lang = lang == "en" ? "en-US" : lang == "tw" ? "zh-TW" : "zh-CN";
				this.request
					.put(`${this.WITSBOX_ENV_PARAM.baseUrl}/user/myAccount`, data)
					.then(res => {
						if (res.success) {}
					});
				this.$store.dispatch("common/changeLanguageDialogVisible", false);
			}
		}
	};
</script>
<style lang="scss">

	.language-dialog {
		.el-radio {
			height: 40px;
			display: block;
		}
	}

	// 菜单高度
	.cal-height {
		height: 100%;

		// @media screen and(max-width:1440px) {
		//   height: calc(100% - 60px);
		// }
	}

	.download-dyned {
		margin: 50px 0;

		&-link {
			font-size: 16px;
			color: #0f2770;
			text-decoration: underline;
			cursor: pointer;
			user-select: none;
		}

		.has-download {
			color: #333;
		}
	}

	.el-message-box__headerbtn {

		top: 0.5rem;
		right: 0.48rem;

		font-size: 0.96rem;

	}

	.el-message-box__header {
		position: relative;
		padding: 0.88rem 0.88rem 0;
	}
	.el-dialog__title {
	  transform: translateY(-0.32rem);
	    font-size: 0.72rem;
	   color: #333333;
	}
	.el-dialog__header {
	    padding: 0.88rem 0.88rem 0;
	}
	.el-dialog__headerbtn {
	    top: 0.5rem;
	    right: 0.48rem;
	    font-size: 0.96rem;
	   
	}
</style>


// WEBPACK FOOTER //
// src/components/Main.vue